import {
  DataLoadingView,
  ErrorOccuredView,
  ModalContainer,
  SectionHeader,
} from "../../../components";
import { currencies } from "../../../constants";
import { productStatus } from "../../../enums";
import {
  HookFormFileUpload,
  HookFormSelect,
  SubmitButton,
  TextArea,
  TextInput,
} from "../../../hook-form";
import { getCurrencyMask } from "../../../utils";
import { IEditProductFormViewProps } from "./EditProductForm";

export const View = ({
  isModalOpen,
  closeModal,
  isLoadingModalData,
  isErrorModalData,

  isLoadingBankAccounts,
  activePayoutTags,
  saveProductIcon,
  actualImage,

  errors,
  handleSubmit,
  register,

  // values used for settings form
  formValues,
}: IEditProductFormViewProps) => {
  return (
    <form onSubmit={handleSubmit} encType="multipart/form">
      <ModalContainer
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        modalHeader={
          <SectionHeader
            title="Edit Product"
            subtitle="Edit an existing product"
            renderRight={
              <SubmitButton
                size="sm"
                className="ml-5 mr-5 pl-5 pr-5"
                showChildrenWithLoadingIcon
              >
                Save changes
              </SubmitButton>
            }
          />
        }
      >
        {isLoadingModalData ? (
          <DataLoadingView message={"Loading product details"} />
        ) : isErrorModalData ? (
          <ErrorOccuredView
            message={
              "An error occured while loading the product details. Please retry..."
            }
          />
        ) : (
          <>
            <TextInput
              name="product_name"
              label="Product Name"
              infoIconText="The name that customers will see"
              type="text"
              register={register}
              errors={errors}
            />

            <div className="flex-container">
              <div className="flex-box">
                <TextInput
                  name="price"
                  label="Price"
                  type="text"
                  onChange={getCurrencyMask("").onChange}
                  register={register}
                  errors={errors}
                />
              </div>

              <div className="flex-box ml-md-5">
                <HookFormSelect
                  name="currency"
                  label="Currency"
                  selectItems={currencies}
                  // selectGroupedItems={}
                  register={register}
                  errors={errors}
                />
              </div>
            </div>

            <div className="flex-container file-upload-container justify-content--between align-items--center">
              <HookFormFileUpload
                name="product_icon"
                buttonLabel="Upload Product thumbnail"
                label="Product Icon"
                labelTitle="Product thumbnail"
                register={register}
                errors={errors}
                className="file-upload-for-product"
                onChange={(e: any) => {
                  saveProductIcon(e);
                  // (e: React.ChangeEvent<HTMLInputElement>) =>
                  // console.log(
                  //   "File Selected: ",
                  //   e.target?.files ? e.target?.files[0] : ""
                  // )
                }}
              />
              <div className="image-preview">
                <img
                  alt="product"
                  className="image-previewer"
                  src={actualImage}
                />
              </div>
            </div>
            <TextArea
              name="product_description"
              label="Description"
              register={register}
              errors={errors}
            />

            <HookFormSelect
              name="payout_tag"
              label="Preferred Payout Account"
              infoIconText="Bank account where sales of this product will be paid out to. Leave empty if you want it to be paid into your primary acct. number."
              showSkeleton={isLoadingBankAccounts}
              selectItems={[]}
              selectGroupedItems={
                activePayoutTags.map((acct) => ({
                  groupLabel: `${acct.account_name} - ${acct.account_number} (${acct.bank_name})`,
                  options: acct.bank_account_tags.map((tag) => ({
                    text: `${tag.tag_name}`,
                    value: tag.id,
                  })),
                })) || []
              }
              register={register}
              errors={errors}
            />

            {/* <div className="flex-container">
          <div className="flex-box">
            <Checkbox
              name="is_subscription_product"
              label="Is Recurring"
              infoIconText="Indicates if a customer purchasing can subscribe to this product"
              register={register}
              errors={errors}
            />
          </div>

          <div className="flex-box ml-md-5">
            <HookFormSelect
              name="subscription_period"
              label="Subscription Period"
              selectItems={Object.values(subscription_period).map((m) => ({
                text: m,
                value: m,
              }))}
              disabled={!formValues.is_subscription_product}
              register={register}
              errors={errors}
            />
          </div>
        </div> */}

            {/* <HookFormSelect
              name="status"
              label="Status"
              selectItems={Object.values(productStatus).map((m) => ({
                text: m,
                value: m,
              }))}
              // selectGroupedItems={}
              register={register}
              errors={errors}
            /> */}
          </>
        )}
      </ModalContainer>
    </form>
  );
};
